import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../../icon';
import Heading from '../../../heading';

const StepMarker = ({
  label = '',
  active,
  passed,
  completed,
  invalid,
  disabled,
  className = '',
  children,
  onClick = null,
}) => {
  const isInteractive = onClick;
  const classes = classNames('ws-ui-step-line-marker', className, {
    'ws-ui-step-line-marker--interactive': isInteractive,
    'ws-ui-step-line-marker--active': active,
    'ws-ui-step-line-marker--passed': passed,
    'ws-ui-step-line-marker--completed': completed,
    'ws-ui-step-line-marker--invalid': invalid,
    'ws-ui-step-line-marker--disabled': disabled,
  });

  const interactiveProps = {
    role: 'button',
    'aria-label': label,
    tabIndex: '0',
    onClick,
  };

  return (
    <div className={classes} {...(isInteractive && interactiveProps)}>
      {completed ? (
        <Icon glyph="check" type="white" />
      ) : (
        <Heading type="heading-6" {...(disabled && { appearance: 'low-emphasis' })}>
          {children}
        </Heading>
      )}
    </div>
  );
};

StepMarker.propTypes = {
  label: PropTypes.string,
  active: PropTypes.bool.isRequired,
  passed: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

export default StepMarker;
